import * as R from 'ramda'

/** Keep in sync with portal `KIOSK_MEMBERSHIP_POS_FLOW_QUERY_PARAM`. */
export const KIOSK_MEMBERSHIP_POS_FLOW_QUERY_PARAM = 'posMembershipFlow'

const memberComparator = R.ascend(R.prop('member'))
const priorityPatientComparator = (patientId) =>
  R.descend(R.pathEq(['patient', 'id'], patientId))
const patientNameComparator = R.ascend(
  R.compose(R.toLower, R.path(['patient', 'name'])),
)

export const sortMembershipsByPriorityPatient = (priorityPatientId) =>
  R.sortWith(
    [
      memberComparator,
      ...[priorityPatientId && priorityPatientComparator(priorityPatientId)],
      patientNameComparator,
    ].filter(Boolean),
  )
